<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <p>
            &copy; Copyright {{ year }} - {{ config.appName }} |
            {{ config.appDeveloper }}
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'Footer',
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
  computed: {
    ...mapGetters('app', ['config']),
  },
};
</script>
